import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Menu from './menu';
import Footer from './footer';
import AutoTransferAppJa from './auto-transfer-app-ja';
import AutoTransferAppEn from './auto-transfer-app-en';
import AutoTransferAppCh from "./auto-transfer-app-ch";

class GuideAutoTransferApp extends Component {
  componentDidMount () {
    setTimeout(() => this.node.scrollIntoView(), 0);
  }
  
  render() {
    const language = localStorage.getItem('i18nextLng');
    let atContent;
    switch (language) {
      case 'ja':
        atContent = <AutoTransferAppJa/>;
        break;
      case 'ch':
        atContent = <AutoTransferAppCh/>;
        break;
      default:
        atContent = <AutoTransferAppEn/>;
    }
    
    return (
      <I18n ns="translations">
        {
          (t, {i18n}) => (
            <div id="wraper-other" ref={node => this.node = node}>
              <header>
                <Menu/>
              </header>
              <div id="auto-transfer-app">
                {atContent}
              </div>
              <Footer/>
            </div>
          )
        }
      </I18n>
    );
  }
}

export default GuideAutoTransferApp;



// WEBPACK FOOTER //
// ./src/containers/guide-auto-transfer-app.jsx